import { Link, useNavigate } from 'react-router-dom';
import { useEmail } from '../../../email/useEmail';
import { ReactNode } from 'react';

export const NoClipMessage: React.FC = () => {
  const navigate = useNavigate();
  const { getEmailLink } = useEmail();

  const goToIntegrations = () => {
    navigate('/settings?tab=integrations');
  };

  return (
    <div style={{ width: '550px', marginTop: '-100px' }}>
      <h1>No Clips Found</h1>
      <p>
        Try changing your applied filters, or in case you didn't create any clip yet, we invite you
        to access any meeting <Link to="/meetings/past">here</Link> and start creating clips.
      </p>

      <p>
        Still stuck? Send an email to
        <a
          href={getEmailLink({
            subject: 'Trouble finding my clips',
            to: ['support@update.ai'],
            body: '',
          })}
          target="_blank"
          rel="noopener noreferrer"
          style={{ paddingLeft: '4px' }}
        >
          support@update.ai
        </a>{' '}
        and give us the title and date of at least one clip that should be showing up.
      </p>

      <p>Sorry for the hassle – we're here to help!</p>
    </div>
  );
};
